import React, { useContext, useState, useEffect } from 'react';
import { AuthContext } from '../../context/auth';;
import Header from '../../components/Header';
import MenuActividadEconomica from '../../components/hacienda/actividadEconomica/menuActividadEconomica';
import Barra from '../../components/barra';
import { ActualizarRenovacion } from '../../components/hacienda/actividadEconomica/modalActualizarRenovacion';
import imagen from '../../imagenes/actividadeconomica.png'


function SolicitudRenovacion() {

  const [liquidador, setLiquidador] = useState(localStorage.getItem('liquidador'));
  const [liquida, setLiquida] = useState(localStorage.getItem('liquida'));
  const [idUsuario, setIdUsuario] = useState();
  const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
  const [espiritu, setEspiritu] = useState(localStorage.getItem('espiritu'));
  const [anio, setAnio] = useState();
  const [mostrar5, setMostrar5] = useState(false);
  const [anioEfis, setAnioEfis] = useState();

  const { user } = useContext(AuthContext);
  let op = require('../../../src/modulos/datos');

  useEffect(() => {

    let obj = JSON.parse(localStorage.getItem('post'));
    setIdUsuario(obj.idusuario);
    //setEspiritu(obj.espiritu);
    setLiquidador(obj.liquidador);
    setLiquida(obj.liquida);
    setFechaSistema(obj.fechasistema);
    setEspiritu(obj.espiritu);
    setAnioEfis(obj.anioefis);
    var nanio = []
    var aini = parseInt(obj.anioactu) - 7;
    var afin = parseInt(obj.anioactu);
    for (let i = 1; i <= afin - aini; i++) {
      nanio.push({ anio: aini + i });

    }
    setAnio(nanio);
    setMostrar5(true);
  }, []);

  const handleCancelaRenovacionLic = () => {
    setMostrar5(false);
    window.location.href = '/actividadEconomica';
  }

  const handleRenovacionLic = () => {
    setMostrar5(true)
  }

  return (

    user && (

      <div style={{ height: "100vh", padding: 0 }}>
        <div className="col-md-12" style={{ height: "10%", padding: 0 }}>
          <Header />
        </div>
        <div className="row col-md-12" style={{ height: "90%", padding: 0, margin: 0 }}>
          <Barra />
          <div className="col-md-10" style={{ height: "100%", padding: 0 }}>
            <div className="col-md-12" style={{ height: "10%", padding: 0 }}>
              <MenuActividadEconomica />
            </div>
            <div className="col-md-12" style={{ height: "90%", padding: 0 }}>
              <ActualizarRenovacion
                show={mostrar5}
                onHideCancela={handleCancelaRenovacionLic}
                onHideAcepta={handleRenovacionLic}
                idusuario={idUsuario}
                liquidador={liquidador}
                fechasistema={fechaSistema}
                espiritu={espiritu}
                anios={anio}
              />
              <img src={imagen} alt="" height="100%" width="100%" />

            </div>
          </div>
        </div>
      </div>

    )


  );
}


export default SolicitudRenovacion;
